import React from 'react';
import { Row, Col, Panel, Timeline } from 'rsuite'; // Assuming you're using rsuite
import Loader from 'react-loader-spinner'; // Assuming you're using react-loader-spinner

function LoadCaseHistoryDiv({ isInventoryLoadCasesHistoryLoading, InventoryLoadCasesHistoryData }) {
    if (isInventoryLoadCasesHistoryLoading) {
        return (
            <div align="center">
                <section className="panel">
                </section>
                <Loader
                    type="TailSpin"
                    color="#3396E5"
                    height="50"
                    width="50"
                />
            </div>
        );
    }

    if (typeof (InventoryLoadCasesHistoryData[0]) !== 'undefined' && InventoryLoadCasesHistoryData != null) {
        return (
            <div>
                <Row>
                    <Col md={24} sm={24}>
                        <Panel bordered header="Load Case History" style={{ marginBottom: 10 }}>
                            <Timeline>
                                {InventoryLoadCasesHistoryData.map(item => (
                                    <Timeline.Item key={item.LoadCaseHistoryID}>
                                        {item.CreatedDT}  &nbsp;
                                        {item.EmailAddr}
                                        <l></l>
                                        {item.HistoryNotes != null ? <l><br /> {item.HistoryNotes} </l> : ' '}                                       
                                        {item.PalletBarcode != null ? <l><br /> Pallet Barcode:  {item.PalletBarcode} </l> : ' '}                            
                                        {item.CaseBarcode != null ? <l><br /> Case Barcode:  {item.CaseBarcode} </l> : ' '}
                                    </Timeline.Item>
                                ))}
                            </Timeline>
                        </Panel>
                    </Col>
                </Row>
            </div>
        );
    }

    return <div></div>;
}

export default LoadCaseHistoryDiv;

